import { render, staticRenderFns } from "./other_partners.vue?vue&type=template&id=907457c0&lang=pug"
import script from "./other_partners.vue?vue&type=script&lang=js"
export * from "./other_partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports